import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";
  constructor(private http: HttpClient) { }

  searchEmployee(itemType: string, searchTerm: string): Observable<TypeaheadOption[]> {
    return this.http.get<TypeaheadOption[]>(this.rootUri + `/api/typeahead/${itemType}?search-term=${searchTerm}`);
  }

  getEmployeeDetails(id: string): Observable<EmployeeDetails> {
    return this.http.get<EmployeeDetails>(this.rootUri + `/api/admin/employee/${id}`);
  }

  updateEmployeeContactInfo(empid: string, data: object): Observable<EmployeeDetails> {
    return this.http.post<EmployeeDetails>(this.rootUri + `/api/admin/employee/${empid}/update`, data);
  }

  newEmployee(data: object): Observable<any> {
    return this.http.post<any>(this.rootUri + `/api/admin/employee/new`, data);
  }

  checkEmail(data: object): Observable<any> {
    return this.http.post<any>(this.rootUri + `/api/admin/employee/check-email`, data);
  }

  updateEmployeePassword(empid: string, payload): Observable<any> {
    return this.http.post<any>(this.rootUri + `/api/admin/employee/${empid}/update-password`,  payload);
  }

}
